import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useAuditMode } from "../../context/AuditMode/AuditModeContext";

const AuditModeBanner = () => {
  const { auditActive, auditTarget, exitAudit } = useAuditMode();

  if (!auditActive) return null;

  return (
    <Box
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        background: "linear-gradient(90deg, #b71c1c 0%, #e53935 100%)",
        color: "#fff",
        padding: "8px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 8px rgba(183, 28, 28, 0.45)",
        flexShrink: 0,
      }}
    >
      <Box display="flex" alignItems="center" style={{ gap: 10 }}>
        <VisibilityIcon fontSize="small" />
        <Typography variant="body2" style={{ fontWeight: 600, letterSpacing: "0.3px" }}>
          Modo Auditoría — Visualizando el panel de{" "}
          <strong style={{ textDecoration: "underline" }}>{auditTarget?.name}</strong>
          {" "}(Solo Lectura)
        </Typography>
      </Box>

      <Button
        size="small"
        variant="outlined"
        onClick={exitAudit}
        startIcon={<ExitToAppIcon />}
        style={{
          color: "#fff",
          borderColor: "rgba(255,255,255,0.6)",
          fontWeight: 700,
          whiteSpace: "nowrap",
          marginLeft: 16,
        }}
      >
        Salir del Modo Espejo
      </Button>
    </Box>
  );
};

export default AuditModeBanner;
